module.exports = __webpack_public_path__ + "img/sku-icon.61140d6.png";